import React, {useState} from 'react'

import {Tournament} from '../types'

import {Grid, Button, Icon, Segment, Progress} from 'semantic-ui-react'

import {GetFormattedDate, GetTournamentProgress} from '../utils/Common'

import ConfirmModal from '../utils/ConfirmModal'

import { useNavigate } from 'react-router-dom'


const TournamentUnit = (props:{tournamentKey:string}) => {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const navigate = useNavigate()

   
    const getTour = () => {
        const tour = localStorage.getItem(props.tournamentKey);
        return JSON.parse(tour + '') as Tournament
    }


    const tournament = getTour();
    if(tournament == null) return(<></>)

    const ExportButton = () => {
        return(
            <Button 
                animated 
                basic
                className='melee'
                onClick={() => exportTour()}
            >
                <Button.Content visible>
                    <Icon name='download' />
                </Button.Content>
                <Button.Content hidden>Export</Button.Content>
            </Button>
        )
    }


    const GoToButton = () => {
        const id = tournament.Id.split('#')[1];
        return(
            <Button 
                animated 
                onClick={() => navigate(`/tournament/${id}`)}
                basic
                className='melee'
            >
                <Button.Content visible>
                    <Icon name='hand point right' />
                </Button.Content>
                <Button.Content hidden>Open</Button.Content>
            </Button>
        )
    }

    const DeleteTournament = () => {
        if(tournament.Id)
            localStorage.removeItem(tournament.Id)
    }

    const RemoveButton = () => {
        return(
            <Button animated basic onClick={() => setConfirmModalOpen(true)} className="melee" tabIndex="-1">
                    <Button.Content visible>
                        <Icon name='remove circle' />
                    </Button.Content>
                    <Button.Content hidden>Delete</Button.Content>
            </Button>
        )
    }

    const getTourFileName = (tourName:string) => {
        const words = tourName.split(' ');
        let fileName = "";
        for(var i = 0; i  < words.length; i++){
            var tempWord = words[i];    
            fileName += tempWord;
            if(i !== words.length-1) fileName += '_'
        }
        return fileName
    }


    const exportTour = async () => {
        const json = JSON.stringify(tournament);
        const blob = new Blob([json],{type:'application/json'});
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = getTourFileName("" + tournament.Name) + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    const progress = GetTournamentProgress(tournament);

    return(
        <>
        <Segment className='tour-unit' style={{backgroundColor: 'transparent', textAlign:'left'}}>

            <h1>{tournament.Name ? tournament.Name : tournament.Id}</h1>
            
            <Grid columns='equal' stackable>
                <Grid.Column>
                    <p>{tournament.CreatedAt && GetFormattedDate(tournament.CreatedAt)}</p>
                </Grid.Column>
                <Grid.Column>
                    <p style={{textTransform: 'capitalize'}}>{tournament.DraftOptions.gameType}</p>
                </Grid.Column>
                <Grid.Column>
                    <p>{tournament.Players.length} players</p>
                </Grid.Column>
                <Grid.Column>
                    <p>{`${progress.gamesCompleted}/${progress.games} games completed`}</p>
                </Grid.Column>
                <Grid.Column width={'1'}>
                    {GoToButton()}
                </Grid.Column>
                <Grid.Column width={'1'}>
                    {ExportButton()}
                </Grid.Column>
                <Grid.Column width={'1'}>
                    {RemoveButton()}
                </Grid.Column>
            </Grid>
            <br></br>
            <Progress value={progress.gamesCompleted} total={progress.games} indicating/>
        </Segment>

        <ConfirmModal 
            isOpen={confirmModalOpen}
            onAccept={DeleteTournament}
            textContent={"Are you sure you want to delete this tournament?"}
            toggleOpen={setConfirmModalOpen}
        />
        </>
    )
}

export default TournamentUnit;